// Google Analytics (GA4)
//
// Jak podłączyć własne konto:
// 1. Załóż konto/usługę w https://analytics.google.com (Admin -> Utwórz usługę -> Strona internetowa)
// 2. Skopiuj "Identyfikator pomiaru" w formacie G-XXXXXXXXXX
// 3. Wklej go poniżej w miejsce GA_MEASUREMENT_ID
// Dopóki zostanie tu wartość placeholder, skrypt Analytics w ogóle się nie wczyta
// (żeby nie zaśmiecać konsoli błędami ani nie wysyłać pustych danych).

export const GA_MEASUREMENT_ID = "G-XESTRE6ZPB";

let initialized = false;

export function isGaConfigured() {
  return Boolean(GA_MEASUREMENT_ID) && GA_MEASUREMENT_ID !== "G-XXXXXXXXXX";
}

export function initGA() {
  if (!isGaConfigured() || initialized) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID);
}

export function trackPageView(path) {
  if (!isGaConfigured() || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
  });
}
